import React, { Component } from 'react';
import { withScrollDisable } from '../hocs/scroll';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

class ModalFull extends Component {
    render() {
        return (
            <div
                className={`ckp-modal-full ${this.props.className ? this.props.className : ''} ${
                    this.props.open ? 'is-open' : ''
                }`}
            >
                <div className="ckp-modal-full-container">
                    <IconButton className="ckp-modal-full-close" onClick={this.props.onClose} color="inherit">
                        <CloseIcon />
                    </IconButton>
                    <div className="ckp-modal-full-body">{this.props.children}</div>
                </div>
            </div>
        );
    }
}

export default withScrollDisable(ModalFull, 500);



// WEBPACK FOOTER //
// ./src/components/helpers/ModalFull.js